import {
  CustomButton,
  CustomCollapseCard,
  CustomDatePicker,
  CustomForm,
  CustomFormItem,
  CustomImage,
  CustomSelect,
  Option,
  Text,
  useText,
} from '@src/components';
import '@src/styles/myInvoices/invoiceFilter.scss';
import iconSearchWhite from '@src/assets/icons/icon-white-search.svg';
import { Form } from 'antd';
import React, { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getPagedList } from '@src/store/slice/invoiceSlice';
import dayjs from '@src/utils/day';
import PropTypes from 'prop-types';
import { VouIdCode } from '@src/store/enums';

const InvoiceFilter = ({ isCompliments = false, isMarket = false, vouId }) => {
  const [form] = Form.useForm();

  const dispatch = useDispatch();
  const { selectedCustomer } = useSelector((state) => state?.customer);

  const [selectedStartDate, setSelectedStartDate] = useState(null);
  const [selectedEndDate, setSelectedEndDate] = useState(null);

  const paymentInformation = [
    { id: 0, value: useText('notPaid') },
    { id: 1, value: useText('partiallyPaid') },
    { id: 2, value: useText('paid') },
  ];

  const onFinish = useCallback(
    async (values) => {
      const body = {
        ...values,
        customerId: selectedCustomer?.customerId,
        vouId: vouId,
      };
      dispatch(getPagedList({ body }));
    },
    [form, dispatch, selectedCustomer],
  );

  const handleClear = useCallback(async () => {
    form.resetFields();
    againLoadInvoiceList();
    setSelectedStartDate(null);
    setSelectedEndDate(null);
  }, [form]);
  const againLoadInvoiceList = useCallback(() => {
    const body = {
      customerId: selectedCustomer?.customerId,
      vouId: vouId,
    };

    dispatch(getPagedList({ body }));
  }, [dispatch, selectedCustomer?.customerId, vouId]);

  const updateStartDate = (date) => {
    setSelectedStartDate(date);
  };

  const updateEndDate = (date) => {
    setSelectedEndDate(date);
  };

  const disabledDate = (current) => {
    return current && current.valueOf() < dayjs(selectedStartDate);
  };

  const disableStartDate = (current) => {
    return current && current.valueOf() > dayjs(selectedEndDate);
  };

  return (
    <CustomCollapseCard
      className={`card-filter-card ${isCompliments || isMarket ? 'comp-f-card' : ''}`}
      cardTitle={<Text t="filters" />}
    >
      <CustomForm
        name="filterForm"
        className="filter-form"
        autoComplete="off"
        onFinish={onFinish}
        initialValues={{
          cardStatus: null,
        }}
        layout={'horizontal'}
        form={form}
      >
        <div className="form-item-container">
          <div
            className="form-items"
            style={{ display: 'flex', justifyContent: 'space-between', flex: 3 }}
          >
            <CustomFormItem
              label={
                <div>
                  <Text t="startDate" />
                  <span>:</span>
                </div>
              }
              name="startDate"
              className="active-date-form-item"
              getValueFromEvent={(onChange) => onChange && dayjs(onChange).format('YYYY-MM-DD')}
              getValueProps={(i) => dayjs(i)}
            >
              <CustomDatePicker
                id="ticketRestaurant-myInvoices-myInvoices-invoiceFilter-startDate-datePicker"
                placeholder={useText('pickDate')}
                onChange={updateStartDate}
                disabledDate={disableStartDate}
              />
            </CustomFormItem>

            <CustomFormItem
              label={
                <div>
                  <Text t="endDate" />
                  <span>:</span>
                </div>
              }
              name="endDate"
              className="active-date-form-item"
              getValueFromEvent={(onChange) => onChange && dayjs(onChange).format('YYYY-MM-DD')}
              getValueProps={(i) => dayjs(i)}
            >
              <CustomDatePicker
                id="ticketRestaurant-myInvoices-myInvoices-invoiceFilter-endDate-datePicker"
                placeholder={useText('pickDate')}
                onChange={updateEndDate}
                disabledDate={disabledDate}
              />
            </CustomFormItem>

            <CustomFormItem
              label={
                <div>
                  <Text t="paymentInformation2" />
                  <span>:</span>
                </div>
              }
              name="paymentStatus"
            >
              <CustomSelect
                id="ticketRestaurant-myInvoices-myInvoices-invoiceFilter-paymentStatus-select"
                placeholder={useText('choose')}
                height={36}
              >
                {paymentInformation.map((x) => (
                  <Option
                    id={`ticketRestaurant-myInvoices-myInvoices-invoiceFilter-paymentStatus-${x?.value}-li`}
                    key={x?.id}
                    value={x?.id}
                  >
                    {x?.value}
                  </Option>
                ))}
              </CustomSelect>
            </CustomFormItem>
          </div>

          <div
            className="form-buttons"
            style={{ justifyContent: 'flex-end', display: 'flex', flex: 1 }}
          >
            <div className="action-buttons">
              <CustomButton
                id="ticketRestaurant-myInvoices-myInvoices-invoiceFilter-clear-btn"
                className="clear-btn"
                onClick={handleClear}
              >
                <Text t="clean" />
              </CustomButton>
              <CustomButton
                id="ticketRestaurant-myInvoices-myInvoices-invoiceFilter-search-btn"
                className="search-btn"
                type="primary"
                htmlType="submit"
              >
                <CustomImage className="icon-search" src={iconSearchWhite} /> <Text t="search" />
              </CustomButton>
            </div>
          </div>
        </div>
      </CustomForm>
    </CustomCollapseCard>
  );
};

InvoiceFilter.propTypes = {
  isCompliments: PropTypes.bool,
  isMarket: PropTypes.bool,
  vouId: PropTypes.number,
};
export default InvoiceFilter;
